// extracted by mini-css-extract-plugin
export var badge = "_i8-2";
export var detailsPanel = "_i8-0";
export var resultRow = "_i8-1";